import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ResourceConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ResourceService } from './api/resource.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ResourceApiModule {
    public static forRoot(configurationFactory: () => ResourceConfiguration): ModuleWithProviders<ResourceApiModule> {
        return {
            ngModule: ResourceApiModule,
            providers: [ { provide: ResourceConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ResourceApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ResourceApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
